import "./Caddie.module.css";
import Navigation from "@/reusable_sections/Header";
import AiAssistance from "./sections/AiAssistance";
import ToolsPreview from "./sections/ToolsPreview";
import StoreFooter from "@/reusable_sections/Footer";
export default function CaddiePage() {
  return <div>
      <Navigation />
      <AiAssistance />
      <ToolsPreview />
      <StoreFooter />
    </div>;
}